import { render, staticRenderFns } from "./RatedJointSimple.vue?vue&type=template&id=980e6160&scoped=true&"
import script from "./RatedJointSimple.vue?vue&type=script&lang=js&"
export * from "./RatedJointSimple.vue?vue&type=script&lang=js&"
import style0 from "./RatedJointSimple.vue?vue&type=style&index=0&id=980e6160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980e6160",
  null
  
)

export default component.exports